import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "@tanstack/react-router";

import { DataTableColumnHeader, DateCell, EmptyValue, RowActions } from "@/components/data-table";
import { CITIES, type CityKey } from "@/constants/cities";
import { ListResponse } from "@/types/lists.types";

import { getListTypeInfo } from "../constants/list-types";
import { ListRowActions } from "./list-row-actions";

const columnHelper = createColumnHelper<ListResponse>();

export const listColumns = [
  columnHelper.accessor("listName", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
    cell: (info) => (
      <Link
        to="/dashboard/lists/detail/$listId"
        params={{ listId: info.row.original.id }}
        className="font-semibold text-foreground hover:text-brand"
      >
        {info.getValue()}
      </Link>
    ),
  }),
  columnHelper.accessor("listType", {
    header: "Type",
    enableSorting: false,
    cell: (info) => <span className="text-muted-foreground">{getListTypeInfo(info.getValue()).label}</span>,
    filterFn: (row, columnId, filterValue) => filterValue === "all" || row.getValue(columnId) === filterValue,
  }),
  columnHelper.accessor("city", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="City" />,
    cell: (info) => {
      const key = info.getValue();
      if (!key) return <EmptyValue />;
      return <span className="text-muted-foreground">{CITIES[key as CityKey]?.name ?? key}</span>;
    },
  }),
  columnHelper.accessor("itemCount", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Places" align="right" />,
    cell: (info) => info.getValue(),
    meta: { align: "right" },
  }),
  columnHelper.accessor("createdAt", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Created" />,
    cell: (info) => <DateCell date={info.getValue()} />,
    sortingFn: "datetime",
  }),
  columnHelper.accessor("updatedAt", {
    header: ({ column }) => <DataTableColumnHeader column={column} title="Updated" />,
    cell: (info) => <DateCell date={info.getValue()} />,
    sortingFn: "datetime",
  }),
  columnHelper.display({
    id: "actions",
    header: "",
    cell: ({ row }) => (
      <RowActions>
        <ListRowActions list={row.original} />
      </RowActions>
    ),
  }),
];
